(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucius-contact"] && !Shopify.designMode) return;
  try {
    
  /* When a quick-route tile is clicked, pre-select the matching option
     in the reason dropdown and smooth-scroll to the form. */
  (function () {
    const tiles = document.querySelectorAll('[data-route-set]');
    const reason = document.querySelector('[data-contact-reason]');
    const subjectInput = document.querySelector('[data-contact-subject]');

    /* Keep subject in sync with reason selection */
    const syncSubject = () => {
      if (!subjectInput || !reason) return;
      const v = reason.value;
      subjectInput.value = v ? `Contact — ${v}` : 'Contact form';
    };

    if (reason) {
      reason.addEventListener('change', syncSubject);
      syncSubject();
    }

    tiles.forEach((tile) => {
      tile.addEventListener('click', (e) => {
        const target = tile.getAttribute('data-route-set');
        if (!target || !reason) return;
        /* Only intercept if there's a matching option — otherwise let the
           tile's own href take over (e.g. pointing to FAQ page). */
        const opt = Array.from(reason.options).find((o) => o.value === target);
        if (opt) {
          e.preventDefault();
          reason.value = target;
          syncSubject();
          const form = document.querySelector('.lucius-contact__form-wrap');
          if (form) form.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucius-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const header = document.querySelector('[data-lucius-header]');
    if (!header) return;

    const toggle = header.querySelector('[data-lucius-drawer-toggle]');
    const drawer = header.querySelector('[data-lucius-drawer]');
    const close = header.querySelector('[data-lucius-drawer-close]');
    if (!toggle || !drawer) return;

    const openDrawer = () => {
      drawer.hidden = false;
      // Force reflow so transition runs
      void drawer.offsetWidth;
      drawer.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('lucius-drawer-open');
    };

    const closeDrawer = () => {
      drawer.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('lucius-drawer-open');
      // Wait for transition, then hide from AT
      window.setTimeout(() => {
        if (!drawer.classList.contains('is-open')) drawer.hidden = true;
      }, 250);
    };

    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      expanded ? closeDrawer() : openDrawer();
    });

    if (close) close.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });

    // Close on link tap
    drawer.addEventListener('click', (e) => {
      const link = e.target.closest('a');
      if (link) closeDrawer();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucius-main-cart"]) return;
  try {
    
  (function () {
    /* Proforma panel toggle */
    const btns = document.querySelectorAll('[data-proforma-toggle]');
    const panel = document.querySelector('[data-proforma-panel]');
    const closeBtn = document.querySelector('[data-proforma-close]');

    const openPanel = () => {
      if (!panel) return;
      panel.hidden = false;
      panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    const closePanel = () => {
      if (panel) panel.hidden = true;
    };

    btns.forEach((b) => b.addEventListener('click', openPanel));
    if (closeBtn) closeBtn.addEventListener('click', closePanel);

    /* Quantity +/- buttons */
    document.querySelectorAll('[data-qty-step]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const line = btn.getAttribute('data-target-line');
        const dir = Number(btn.getAttribute('data-step-dir'));
        const input = document.querySelector(`[data-qty-input][data-target-line="${line}"]`);
        if (!input) return;
        const next = Math.max(0, (parseInt(input.value, 10) || 0) + dir);
        input.value = next;
        /* Live-submit for a snappier update */
        const form = input.closest('form');
        if (form) form.submit();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucius-main-collection"]) return;
  try {
    
  /* Mobile filter drawer toggle */
  (function () {
    const openBtn = document.querySelector('[data-filters-open]');
    const closeBtn = document.querySelector('[data-filters-close]');
    const drawer = document.querySelector('.lucius-coll__filters');
    if (!openBtn || !drawer) return;

    const open = () => {
      drawer.classList.add('is-open');
      document.body.classList.add('lucius-filters-open');
    };
    const close = () => {
      drawer.classList.remove('is-open');
      document.body.classList.remove('lucius-filters-open');
    };

    openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    document.addEventListener('click', (e) => {
      if (document.body.classList.contains('lucius-filters-open')
          && !drawer.contains(e.target)
          && !openBtn.contains(e.target)) {
        close();
      }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucius-main-login"] && !Shopify.designMode) return;
  try {
    
  /* Form panel toggling (login ↔ recover). Uses URL hash for deep links. */
  (function () {
    const root = document.querySelector('[data-lucius-login]');
    if (!root) return;

    const panels = root.querySelectorAll('[data-panel]');
    const links = document.querySelectorAll('[data-panel-link]');

    const show = (target) => {
      panels.forEach((p) => {
        const active = p.dataset.panel === target;
        p.classList.toggle('is-active', active);
        p.hidden = !active;
      });
    };

    links.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const target = link.dataset.panelLink;
        show(target);
        history.replaceState(null, '', '#' + target);
      });
    });

    /* Deep link via hash (#recover) */
    const initial = window.location.hash.replace('#', '');
    if (initial && root.querySelector(`[data-panel="${initial}"]`)) {
      show(initial);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucius-main-product"]) return;
  try {
    
  /* Add-to-cart total = unit price × qty (the unit price comes from a
     data attribute set by Liquid based on customer trade status).
     Plus the gallery thumb swap and qty +/- buttons. */
  (function () {
    const root = document.querySelector('[data-lucius-pd]');
    if (!root) return;

    const configEl = root.querySelector('[data-lucius-pd-config]');
    let moneyFormat = '';
    if (configEl) {
      try {
        moneyFormat = JSON.parse(configEl.textContent).moneyFormat || '';
      } catch (e) {
        /* fall through with empty format — money() defaults to £ prefix */
      }
    }

    const qtyInput = root.querySelector('[data-qty-input]');
    const qtyInc = root.querySelector('[data-qty-inc]');
    const qtyDec = root.querySelector('[data-qty-dec]');
    const addBtn = root.querySelector('[data-add-button]');
    const addTotal = root.querySelector('[data-add-total]');
    const unitCents = parseInt(addBtn && addBtn.dataset.unitCents, 10) || 0;

    const AMOUNT_RE = /\{\{\s*amount\s*\}\}/g;
    const money = (cents) => {
      const formatted = Number((cents / 100).toFixed(2)).toLocaleString('en-GB', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      if (!moneyFormat) return '£' + formatted;
      return moneyFormat.replace(AMOUNT_RE, formatted);
    };

    const update = () => {
      let qty = parseInt(qtyInput.value, 10);
      if (!Number.isFinite(qty) || qty < 1) qty = 1;
      qtyInput.value = qty;
      if (addTotal) addTotal.textContent = money(unitCents * qty);
    };

    if (qtyInput) qtyInput.addEventListener('input', update);
    if (qtyInc) qtyInc.addEventListener('click', () => {
      qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + 1);
      update();
    });
    if (qtyDec) qtyDec.addEventListener('click', () => {
      qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
      update();
    });

    /* Thumbnail swap */
    const thumbs = root.querySelectorAll('[data-thumb]');
    const mainImg = root.querySelector('[data-main-img]');
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (mainImg) {
          mainImg.src = thumb.dataset.thumbSrc;
          mainImg.alt = thumb.dataset.thumbAlt;
        }
        thumbs.forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });

    /* Initial render to sync defaults */
    if (qtyInput) update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucius-product-tabs"]) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-lucius-tabs]');
    if (!root) return;

    const btns = root.querySelectorAll('[data-tab-btn]');
    const panels = root.querySelectorAll('[data-tab-panel]');

    btns.forEach((btn) => {
      btn.addEventListener('click', () => {
        const target = btn.dataset.tabBtn;
        btns.forEach((b) => {
          const active = b === btn;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach((p) => {
          const active = p.dataset.tabPanel === target;
          p.classList.toggle('is-active', active);
          p.hidden = !active;
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucius-trade-application"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const form = document.querySelector('[data-ta-form]');
    if (!form) return;

    const steps = Array.from(form.querySelectorAll('[data-step]'));
    const dots = Array.from(document.querySelectorAll('[data-step-dot]'));
    const nextBtns = form.querySelectorAll('[data-step-next]');
    const backBtns = form.querySelectorAll('[data-step-back]');
    const noteInput = form.querySelector('[data-ta-note]');
    const bizFields = form.querySelectorAll('[data-biz-field]');
    const chInput = form.querySelector('[data-ch-input]');
    const chStatus = document.querySelector('[data-ch-status]');

    let currentStep = 1;

    const showStep = (n) => {
      steps.forEach((s) => {
        const match = Number(s.dataset.step) === n;
        s.classList.toggle('is-active', match);
        s.hidden = !match;
      });
      dots.forEach((d) => {
        const dn = Number(d.dataset.stepDot);
        d.classList.toggle('is-active', dn === n);
        d.classList.toggle('is-done', dn < n);
      });
      currentStep = n;
      window.scrollTo({ top: form.offsetTop - 80, behavior: 'smooth' });
    };

    /* HTML5 validation for the current step before advancing */
    const validateStep = (n) => {
      const step = steps.find((s) => Number(s.dataset.step) === n);
      if (!step) return true;
      const fields = step.querySelectorAll('input[required], select[required], textarea[required]');
      for (const f of fields) {
        if (!f.checkValidity()) {
          f.reportValidity();
          return false;
        }
      }
      return true;
    };

    nextBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (validateStep(currentStep)) showStep(currentStep + 1);
      });
    });

    backBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        showStep(Math.max(1, currentStep - 1));
      });
    });

    /* Companies House format check (client-side only — real verification
       happens in the admin). 8 characters, alphanumeric. */
    if (chInput && chStatus) {
      const check = () => {
        const v = (chInput.value || '').trim();
        if (v === '') {
          chStatus.textContent = '';
          chStatus.removeAttribute('data-ch-state');
          return;
        }
        const valid = /^[A-Za-z0-9]{8}$/.test(v);
        chStatus.textContent = valid ? '✓ Format valid' : '⚠ Must be 8 characters';
        chStatus.dataset.chState = valid ? 'ok' : 'bad';
      };
      chInput.addEventListener('input', check);
      chInput.addEventListener('blur', check);
    }

    /* Before submit, bundle all business fields into customer[note]. */
    form.addEventListener('submit', (e) => {
      if (!validateStep(4)) {
        e.preventDefault();
        return;
      }
      const lines = ['=== TRADE APPLICATION ==='];
      bizFields.forEach((f) => {
        const key = f.dataset.bizKey || f.name;
        const val = (f.value || '').trim();
        if (val) lines.push(`${key}: ${val}`);
      });
      lines.push('=== END APPLICATION ===');
      noteInput.value = lines.join('\n');
      /* Strip biz[*] inputs so Shopify doesn't complain. */
      bizFields.forEach((f) => { f.disabled = true; });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
